import { defineInvokeEventa, defineOutboundEventa } from "@moeru/eventa";
//#region src/index.ts
const sendMessages = defineInvokeEventa("chat:send-messages");
const pullMessages = defineInvokeEventa("chat:pull-messages");
const newMessages = defineOutboundEventa("chat:new-messages");
//#endregion
export { newMessages, pullMessages, sendMessages };

//# sourceMappingURL=index.mjs.map